var _defs, _style, _circle, _line, _line2, _line3, _line4, _line5, _circle2, _text, _text2, _text3, _text4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg45CeilingMounting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 320,
    viewBox: "0 0 320 320",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrowhead",
    markerWidth: 12,
    markerHeight: 12,
    refX: 6,
    refY: 6,
    orient: "auto",
    markerUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 12,6 0,12",
    fill: "blue"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .thick { stroke: black; stroke-width: 6; fill: none; }\n    .arrow { stroke: blue; stroke-width: 2; fill: none; marker-end: url(#arrowhead); }\n    .blue-dot { fill: blue; stroke: none; }\n    .label { fill: blue; font-size: 14px; font-family: sans-serif; }\n  ")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "thick",
    cx: 150,
    cy: 150,
    r: 80
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "thick",
    x1: 93.4314575050762,
    y1: 93.43145750507621,
    x2: 65.35864126760109,
    y2: 65.3586412676011
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "arrow",
    x1: 150,
    y1: 150,
    x2: 150,
    y2: 10
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "arrow",
    x1: 150,
    y1: 150,
    x2: 150,
    y2: 290
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "arrow",
    x1: 150,
    y1: 150,
    x2: 290,
    y2: 150
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "arrow",
    x1: 150,
    y1: 150,
    x2: 10,
    y2: 150
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "blue-dot",
    cx: 150,
    cy: 150,
    r: 9
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 275,
    y: 140
  }, "xMax")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 10,
    y: 140
  }, "xMin")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 165,
    y: 20
  }, "yMax")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 165,
    y: 290
  }, "yMin")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg45CeilingMounting);
export default __webpack_public_path__ + "static/media/45ceiling_mounting.5feceda2dc97753fd99fe111203a3e06.svg";
export { ForwardRef as ReactComponent };